"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
Object.defineProperty(exports, "onlyRenderFailedIfNoData", {
  enumerable: true,
  get: function () {
    return _WaitForData.onlyRenderFailedIfNoData;
  }
});
var React = _interopRequireWildcard(require("react"));
var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));
var _Loader = _interopRequireDefault(require("./Loader"));
var _NotificationMessage = _interopRequireDefault(require("./NotificationMessage"));
var _WaitForData = _interopRequireWildcard(require("../utils/WaitForData"));
const WaitForData = props =>
/*#__PURE__*/
// @ts-ignore
React.createElement(_WaitForData.default, Object.assign({
  LoadingComponent: _Loader.default,
  FailedLoadComponent: _ErrorMessage.default,
  NoContentComponent: _NotificationMessage.default
}, props));
WaitForData.defaultProps = {
  failedInitial: 'General.Error',
  noContent: 'General.Error',
  loadingMsg: null
};
var _default = exports.default = WaitForData;